/**
 * @file 业务入口
 */

import { createRequest, ContentTypeEnum, Transform, getCancelError, REQUEST_METHOD } from '@da-vinci/utils'
import { ErrorCodeEnum, ErrorMessageEnum } from '@/enums'
import { Message } from '@mogic/dv-design'
import { useUserStore } from '@/store'

let catchError: any
const transform: Transform = {
  // 请求拦截，修改请求头
  requestInterceptors: (config) => {
    const useStore = useUserStore()
    if (config.method?.toUpperCase() === REQUEST_METHOD.POST) {
      config.data = { ...config.data, tenantId: useStore.tenantId }
    } else {
      config.params = { ...config.params, tenantId: useStore.tenantId }
    }
    const options = config.requestOptions
    if (options?.withToken) {
      if (!config.headers) config.headers = {}
      config.headers['x-access-token'] = useStore.token
      config.headers['x-access-key'] = useStore.userInfo?.orgList?.[0]?.orgId ?? 5
    }
    return config
  },
  // 响应内容的出错兜底
  responseCatch: (error: any, options) => {
    if (catchError === error) {
      throw error
    }
    const { code, message } = error?.data || {}
    const useStore = useUserStore()
    if (code === ErrorCodeEnum.TOKEN_EXPIRED) {
      useStore.logout() // 判断token过期
    }

    const { errorMessageMode, ignoreMessage } = options
    let msg = message || '系统遇到错误，请重试'
    if (code === 520013) {
      msg = '链接不是一个视频内容，请检查'
    }
    if (code === 520010) {
      msg = ''
      Message.warning('团队算力值不足，请联系商务经理进行反馈')
    }
    if (!ignoreMessage && msg && errorMessageMode === ErrorMessageEnum.MESSAGE) {
      Message.error(msg)
    }
    if (code && message) {
      if (__APP_ENV__ === 'dev') {
        const traceId = error.headers?.get?.('x-access-trace-id')
        const path = error.config?.url
        console.log(`${path} code:${code} message:${message} traceId:${traceId} params:${error.config?.data}`)
      }
      throw (catchError = getCancelError())
    } else {
      if (IS.isObject(error?.config)) {
        error.message += '-'
        error.message += error.config?.url
        error.message += '-'
        error.message += error.config?.data
        delete error.config
        delete error.request
      }
      throw (catchError = new Error(JSON.stringify(error?.data ?? error ?? '')))
    }
  },
}

export default createRequest({
  serverMode: __APP_DEV__, // localhost 开发模式
  mockUrl: import.meta.env.VITE_MOCK_URL,
  headers: { 'Content-Type': ContentTypeEnum.JSON },
  timeout: 10 * 1000,
  transform,
  throwCatch: true,

  requestOptions: {
    // 可能会有其他域下的请求
    apiUrl: import.meta.env.VITE_API_URL,
    sysPrefix: '/aiBrain/videoCopy',
    joinPrefix: true,
    needTransformResponse: true, // 需要对返回数据进行处理
    errorMessageMode: ErrorMessageEnum.MESSAGE, // 消息提示类型
    withToken: true, // 是否携带token

    mock: false,
  },
})
